<template>
  <div>
  <b-row>
    <div class="col-12 text-success">
      <label>Seleccione el tipo de procedimiento:</label>
      <b-form-radio-group id="proc-tipo" v-model="tipoProcedimientoSelected"
        :options="tipoProcedimiento"></b-form-radio-group>
      <!-- <v-select
  class="mt-2"
  v-model="procedimientoSelected"
  :items="optionsProcedimiento"
  
  placeholder="Seleccione un procedimiento"
  clearable

></v-select> -->
<div class="mt-1">
 <label>Seleccione el prcedimiento a aplicar:</label>
 <v-select   
   
  v-model="procedimientoSelected"
  :options="optionsProcedimiento"
  label="text"
  :reduce="option => option.value"
  placeholder="Busque..."
  clearable
/>

      <!-- <b-form-select class="mt-2" v-model="procedimientoSelected" placeholder="Seleccione un prcedimiento" :options="optionsProcedimiento"></b-form-select>
-->
</div>
    </div>

    <div class="d-flex justify-content-center align-items-center">
      <div>
      <div class="Odontogram col-12">
        <svg version="1.1" height="100%" width="100%">
          <Teeth :start="18" :end="11" :x="0" :y="20" />
          <Teeth :start="21" :end="28" :x="260" :y="20" />

          <Teeth :start="48" :end="41" :x="0" :y="200" />
          <Teeth :start="31" :end="38" :x="260" :y="200" />

          <Teeth :start="55" :end="51" :x="75" :y="80" />
          <Teeth :start="61" :end="65" :x="240" :y="80" />

          <Teeth :start="85" :end="81" :x="75" :y="140" />
          <Teeth :start="71" :end="75" :x="240" :y="140" />
        </svg>

        <!-- <b-modal id="modal-options">
        <div>
          <b-form-checkbox-group v-model="detallesEncontrados"
            :options="optionsDetallesEncontrados"></b-form-checkbox-group>
           <ul>
        <b-form-checkbox-group>

        </b-form-checkbox-group>        
        <li @click="applyAction('carie', currentZone, 1)">Cavity (Done)</li>
        <li @click="applyAction('carie', 'all', 1)">Cavities All (Done)</li>
        <li @click="applyAction('extract', null, 1)">Absent (Done)</li>
        <li @click="applyAction('crown', null, 1)">Crown (Done)</li>
        <li class="separator"></li>
        <li @click="applyAction('carie', currentZone, 2)">Cavity (To Do)</li>
        <li @click="applyAction('carie', 'all', 2)">Cavities All (To Do)</li>
        <li @click="applyAction('extract', null, 2)">Absent (To Do)</li>
        <li @click="applyAction('crown', null, 2)">Crown (To Do)</li>
        <li @click="applyAction('filter', null, 2)">Filtered Out</li>
        <li @click="applyAction('fracture', null, 2)">Fractured</li>
        <li class="separator"></li>
        <li @click="applyAction('clear')">Clear All</li>
      </ul> 
        </div>
      </b-modal> -->
      </div>
      </div>
    </div>
  </b-row>
    <hr />
    <b-row class="mt-1">

    <TableOdontograma :items="itemsTabla" @update-items="actualizarItems" />


    
    
    <b-col class="col-10">
      <label>Observaciones</label>
      <b-form-textarea v-model="observaciones">

      </b-form-textarea>
    </b-col>
        <b-col class="col-10">
      <label>Prescripciones</label>
      <b-form-textarea v-model="prescripciones">

      </b-form-textarea>
    </b-col>

  </b-row>
  </div>
</template>

<script>
import { BModal, BFormSelect } from 'bootstrap-vue';
import Teeth from './Teeth.vue';
import TableOdontograma from './TableOdontograma.vue';
import vSelect from 'vue-select';

export default {
  name: 'Odontograma',
  components: {
    Teeth,
    BModal,
    BFormSelect,
    TableOdontograma,
    vSelect
  },
  data() {
    return {
      observaciones:null,
      prescripciones:null,
      itemsTabla: [],
      procedimientoSelected: null,
      tipoProcedimientoSelected: '1',
      tipoProcedimiento: [
        { text: 'Por hacer', value: '1' },
        { text: 'Realizado', value: '2' }
      ],

     optionsProcedimiento: [
  { text: 'Caries en la zona', value: 'caz', disabled: false },
  { text: 'Caries en toda la pieza', value: 'cap', disabled: false },
  { text: 'Extraer/Extraida', value: 'ext', disabled: false },
  { text: 'Corona en pieza', value: 'cop', disabled: false },
  { text: 'Sellante', value: 'sellante', disabled: false },
  { text: 'Endodoncia', value: 'end', disabled: false },
  { text: 'Cuello base cavitaria', value: 'cuello', disabled: false },
  { text: 'Restauración', value: 'restauracion', disabled: false },
  { text: 'Incrustación', value: 'incrustacion', disabled: false },
  { text: 'Retratamiento', value: 'retratamiento', disabled: false },
  { text: 'Recromía', value: 'recromia', disabled: false },
  { text: 'Carilla', value: 'carilla', disabled: false },
  { text: 'Alargamiento corona', value: 'alargamiento_corona', disabled: false },
  { text: 'Profilaxis', value: 'profilaxis', disabled: false },
  { text: 'Aplicación de flúor en gel', value: 'aplicacion_fluor_gel', disabled: false },
  { text: 'Aplicación de flúor barniz', value: 'aplicacion_fluor_barniz', disabled: false },
  { text: 'Microabrasión', value: 'microabrasion', disabled: false },
  { text: 'Sensibilidad', value: 'sensibilidad', disabled: false },
  { text: 'Retracción', value: 'retraccion', disabled: false },
  { text: 'Cirugía', value: 'cirugia', disabled: false },
  { text: 'Movilidad dental', value: 'movilidad_dental', disabled: false },
  { text: 'Furca', value: 'furca', disabled: false },
  { text: 'Odontosección', value: 'odontoseccion', disabled: false },
  { text: 'Restos radiculares', value: 'restos_radiculares', disabled: false },
  { text: 'Prótesis removible', value: 'protesis_removible', disabled: false },
  { text: 'Prótesis total', value: 'protesis_total', disabled: false },
  { text: 'Puente', value: 'puente', disabled: false },
  { text: 'Perno', value: 'perno', disabled: false },
  { text: 'Periodoncia', value: 'periodoncia', disabled: false },
  { text: 'Odontoma', value: 'odontoma', disabled: false },
  { text: 'Quiste', value: 'quiste', disabled: false },
  { text: 'Blanqueamiento', value: 'blanqueamiento', disabled: false },
  { text: 'Férula', value: 'ferula', disabled: false },
  { text: 'Placa miorelajante', value: 'placa_miorelajante', disabled: false },
  { text: 'Control ortodoncia', value: 'control_ortodoncia', disabled: false },
  { text: 'Sin espacio', value: 'sin_espacio', disabled: false },
  { text: 'Supernumerario', value: 'supernumerario', disabled: false },
 
],

      procedimientosPorHacer: [],
      procedimientosRealizados: [],
      number: null,
      yaInicializado:false,

      dataTooth: {
        zone: null,
        number: null,
        token:null
      },
      currentZone: null,

      toothStates: [],

      firstUpdate: false,
    };
  },
   props: {
    odontogramaRecibido: {
      type: Object,
      default: null
    },
    esCrear: {
      required:false,
      default: false
    },

  },
  
  methods: {
  actualizarItems(nuevosItems) {
  const tokensNuevos = new Set(
    nuevosItems.map(item => item.token).filter(token => !!token)
  );

  // Limpiar toothStates de los eliminados
  const eliminados = this.itemsTabla.filter(item => !tokensNuevos.has(item.token));
  eliminados.forEach(item => {
    this.removeToothStateByToken(item.token);
  });

  this.itemsTabla = [...nuevosItems];

  this.procedimientosPorHacer = this.procedimientosPorHacer.filter(proc => {
    const token = proc?.piezaDetails?.token;
    return !token || tokensNuevos.has(token);
  });

  this.procedimientosRealizados = this.procedimientosRealizados.filter(proc => {
    const token = proc?.piezaDetails?.token;
    return !token || tokensNuevos.has(token);
  });

  this.emitirOdontograma();
}


,
    emitirOdontograma() {
  this.$emit('update-odontograma', {
    observaciones: this.observaciones,
    prescripciones: this.prescripciones,
    itemsTabla: this.itemsTabla,
    procedimientosPorHacer: this.procedimientosPorHacer,
    procedimientosRealizados: this.procedimientosRealizados,
    toothStates: this.toothStates
  });
},



    agregarState(code, value) {
       let existingState = this.toothStates.find(state => state.id === this.number);

  if (!existingState) {
    const token = this.dataTooth?.token || this.generarToken(this.number, this.currentZone);
    const newToothState = {
      id: this.number,
      token: token,
      Cavities: {
        center: 0,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      },
      Extract: 0,
      Crown: 0,
      Filter: 0,
      Fracture: 0,
      Sellante: 0
    };
        this.toothStates.push(newToothState);
        existingState = newToothState;
      }

      // Ahora, actualizamos el estado basándonos en el tipo de acción
      if (code === 'cavities') {
        // Acumulamos las cavidades sin borrar las otras
        existingState.Cavities[this.currentZone] = value;
      } else if (code === 'allcavities') {
        // Reemplazamos todas las cavidades
        Object.assign(existingState.Cavities, value);
      } else {
        // Para cualquier otra acción, limpiamos todo el estado primero y luego actualizamos solo el campo
        // Limpiamos las cavidades
        //Object.assign(existingState.Cavities, { center: 0, top: 0, bottom: 0, left: 0, right: 0 });

        // Limpiamos los otros estados
        // existingState.Extract = 0;
        // existingState.Crown = 0;
        // existingState.Filter = 0;
        // existingState.Fracture = 0;

        // Ahora aplicamos el nuevo estado
        if (code === 'extract') {
          existingState.Extract = value;
        } else if (code === 'crown') {
          existingState.Crown = value;
        } else if (code === 'filter') {
          existingState.Filter = value;
        } else if (code === 'fracture') {
          existingState.Fracture = value;
        } else if (code === 'sellante') {
          existingState.Sellante = value;
        }
      }
    },
    removeToothStateByToken(token) {
  const tooth = this.toothStates.find(t => t.token === token);
  if (tooth) {
    // Limpiar el estado visual (cavidades y demás)
    Object.assign(tooth.Cavities, {
      center: 0,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    });
    tooth.Extract = 0;
    tooth.Crown = 0;
    tooth.Filter = 0;
    tooth.Fracture = 0;
    tooth.Sellante = 0;
  }
},



    applyAction(type, zone = null, value = null) {

      console.log("entra a aplicar accion", type, zone, value)
      switch (type) {
        case 'carie':

          this.setCavities(zone, value);
          break;
        case 'extract':
          this.agregarState(type, value)

          break;
        case 'crown':
          this.agregarState(type, value)

          break;
        case 'filter':
          this.agregarState(type, value)

          break;
        case 'sellante':
          this.agregarState(type, value)

          break;
        case 'fracture':
          this.agregarState(type, value)

          break;
        case 'enc':
          this.setCavities(zone, value);

          break;
        case 'clear':
          this.clearTooth();
          break;
      }

    },
    setCavities(zone, value) {
      let cavities = {
        center: 0,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      };
      if (zone === 'all') {

        cavities = {
          center: value,
          top: value,
          bottom: value,
          left: value,
          right: value
        };
        this.agregarState('allcavities', cavities)
      } else if (zone) {

        this.agregarState('cavities', value)


      }




    },


  },

  watch: {
    '$store.state.odontologia.dataTooth': {
      deep: true,
      immediate: true,
      async handler(newValue) {
        if (newValue && newValue.zone && newValue.number !== null) {
          // Primero asigna number y zone
          this.dataTooth = newValue;
          this.currentZone = newValue.zone;
          
          this.number = newValue.number;

          let objectProcDiente = {
            piezaDetails: newValue,
            procedimiento: this.procedimientoSelected,
            value: this.tipoProcedimientoSelected ? parseInt(this.tipoProcedimientoSelected) : 0,

          }

          // ✅ Aplica el procedimiento seleccionado
          if (this.tipoProcedimientoSelected === '1' && this.procedimientoSelected) {

            // const found = this.procedimientosPorHacer.find(element =>
            //   element.piezaDetails.number === newValue.number && element.piezaDetails.zone === newValue.zone && element.procedimiento === this.procedimientoSelected
            // );

            
            // if (found) {
            //   objectProcDiente.value = 0;
            // }
                        
            this.procedimientosPorHacer.push(objectProcDiente);

            if (objectProcDiente.value !== 0 && objectProcDiente.value ) {
                this.itemsTabla.push(objectProcDiente);
              } else {
                const enItems = this.itemsTabla.find(element =>
                  element.piezaDetails === newValue && element.procedimiento === this.procedimientoSelected
                );

                if (enItems !== -1) {
                  //this.itemsTabla.splice(enItems, 1);
                }
              }
            
          }

          if (this.tipoProcedimientoSelected === '2' && this.procedimientoSelected) {
            if(this.procedimientoSelected === 'enc') {
              objectProcDiente.value = 4
            }
            
            this.procedimientosRealizados.push(objectProcDiente);
            if (objectProcDiente.value !== 0 && objectProcDiente.value ) {
                this.itemsTabla.push(objectProcDiente);
              } else {
                const enItems = this.itemsTabla.find(element =>
                  element.piezaDetails === newValue && element.procedimiento === this.procedimientoSelected
                );

                if (enItems !== -1) {
                  //this.itemsTabla.splice(enItems, 1);
                }
              }
            
            //this.itemsTabla.push(objectProcDiente)
          }
        }
      }
    },

    toothStates: {
      handler(newVal) {

        // if (this.firstUpdate) {
        //   this.firstUpdate = false;
        // } else {
        //   this.handleToothUpdate(this.number, newVal);
        this.emitirOdontograma();
        this.$store.commit('setToothState', newVal)


        // this.handleToothUpdate(this.number, newVal);
      },
      immediate: true,
      deep: true
    },
    tipoProcedimientoSelected: {
      handler(newVal) {
        const findIn = this.optionsProcedimiento.find(item => item.value === 'enc')
        if (newVal && newVal === '1') {
          if (findIn) {
            this.optionsProcedimiento.pop()
          }
        }
        if (newVal && newVal === '2') {
          if (!findIn) { this.optionsProcedimiento.push(
            { text: 'Encontrado', value: 'enc', disabled: false },
          )}
        }
      },
      deep: true,
      immediate: true
    },

    procedimientosPorHacer: {
      handler(newVal) {
        console.log("por hacer", newVal)
        this.emitirOdontograma();
        if (newVal.length > 0) {
          // Solo procesamos el último elemento, para evitar el bucle infinito
          const value = newVal[newVal.length - 1];
          let election = value.procedimiento;
          let zone = value.piezaDetails.zone;
          let valor = value.value

          switch (election) {
            case 'caz':
              this.applyAction('carie', zone, valor);
              break;
            case 'cap':
              this.applyAction('carie', 'all', valor);
              break;
            case 'ext':
              this.applyAction('extract', null, valor);
              break;
            case 'cop':
              this.applyAction('crown', null, valor);
              break;
            case 'sellante':
              this.applyAction('sellante', null, valor);
              break;
            case 'end':
              this.applyAction('filter', null, valor);
              break;
          }



          // Borra el elemento procesado para no volver a ejecutar la acción
          //this.procedimientosPorHacer.pop();


        }
      },
      deep: true,
      immediate:true,
    },
    
    procedimientosRealizados: {
      handler(newVal) {
         console.log("realizados", newVal)
        this.emitirOdontograma();
        if (newVal.length > 0) {
          // Solo procesamos el último elemento, para evitar el bucle infinito
          const value = newVal[newVal.length - 1];
          let election = value.procedimiento;
          let zone = value.piezaDetails.zone;
          let valor = value.value

          switch (election) {
            case 'caz':
              this.applyAction('carie', zone, valor);
              break;
            case 'cap':
              this.applyAction('carie', 'all', valor);
              break;
            case 'ext':
              this.applyAction('extract', null, valor);
              break;
            case 'cop':
              this.applyAction('crown', null, valor);
              break;
            case 'end':
              this.applyAction('filter', null, valor);
              break;
            case 'sellante':
              this.applyAction('sellante', null, valor);
              break;
            case 'enc':              
              this.applyAction('enc', zone, valor);
              break;
          }

          // Borra el elemento procesado para no volver a ejecutar la acción
          //this.procedimientosPorHacer.pop();

        }
      },
      deep: true,
      immediate:true,
    },
    observaciones: {
  handler() {
    this.emitirOdontograma();
  },
  deep: true,
  immediate:true,
},
prescripciones: {
  handler() {
    this.emitirOdontograma();
  },
  deep: true,
  immediate:true,
},
itemsTabla: {
  handler() {
    this.emitirOdontograma();
  },
  deep: true,
  immediate:true,
},
odontogramaRecibido: {
    handler(newVal) {
      if (!this.yaInicializado && newVal) {
        console.log('🦷 Odontograma recibido:', newVal);

        if (newVal.observaciones !== undefined) {
          this.observaciones = newVal.observaciones;
        }

        if (newVal.prescripciones !== undefined) {
          this.prescripciones = newVal.prescripciones;
        }

        if (Array.isArray(newVal.itemsTabla)) {
          this.itemsTabla = [...newVal.itemsTabla];
        }

        if (Array.isArray(newVal.procedimientosPorHacer)) {
          this.procedimientosPorHacer = [...newVal.procedimientosPorHacer];
        }

        if (Array.isArray(newVal.procedimientosRealizados)) {
          this.procedimientosRealizados = [...newVal.procedimientosRealizados];
        }

        if (Array.isArray(newVal.toothStates)) {
          this.toothStates = [...newVal.toothStates];
        }

        this.emitirOdontograma(); // ✅ Emitimos para informar que se ha cargado
        this.yaInicializado = true;
      }
    },
    immediate: true,
    deep: true
  },






  }
};
</script>

<style scoped>
@import './Odontograma.css';
</style>
